import fn from '@/utils/formatFunctions'

export default {
    methods: {
        ...fn
    }
}